export const SET_SEARCH_TYPE = 'set_search_type';
export const SEARCH_PATIENT_BY_NAME = 'search_patient_by_name';
export const SEARCH_PATIENT_BY_NUMBER = 'search_patient_by_number';
export const SEARCH_PATIENT_BY_NUMBER_ONLY = 'search_patient_by_number_only';
export const SEARCH_PATIENT_BY_SSN = 'search_patient_by_ssn';
export const SEARCH_CAREGIVER_BY_NAME = 'search_caregiver_by_name';
export const SEARCH_CAREGIVER_BY_NUMBER = 'search_caregiver_by_number';
export const SEARCH_CAREGIVER_BY_NUMBER_ONLY = 'search_caregiver_by_number_only';
export const SEARCH_CAREGIVER_BY_SSN = 'search_caregiver_by_ssn';
export const SEARCH_TRANSPORTER = 'search_transporter';
export const CLEAR_SEARCH_RESULTS = 'clear_search_results';
